import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import RLContact from '../components/rl/RLContact';

function ContactPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          📮 Contact & Reviews
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Get in touch, share feedback, and review recent improvements.
        </Typography>
      </Box>

      <RLContact />
    </Container>
  );
}

export default ContactPage;

